import Http from "@/utils/request.js";
import { baseUrl } from "@/app.config.js";
import { useUserStore } from "@/stores/user.js";

//商品列表
export function ProductList(data){
	return Http.request({
		url: `/user/product/getProductList`,
		method: 'post',
		data
	})
}

//商品二维码
export function ProductQrcode(data){
	return Http.request({
		url: `/user/product/getProductMinQr`,
		method: 'post',
		data
	})
}

//商品分类
export function ProductClassify(data){
	return Http.request({
		url: `/user/classify/getProductClassify`,
		method: 'post',
		data
	})
}

//根据类型获取当前分类 
export function ProductClassifyByType(type){
	return Http.request({
		url: `/user/classify/getProductClassifyByType`,
		method: 'post',
		data:{
			type
		}
	})
}

//商品详情
export function ProductDetails(id){
	return Http.request({
		url: `/user/product/getProductDetail`,
		method: 'post',
		data:{
			id
		}
	})
}

//评价------
//评价列表
export function CommentsList(data){
	return Http.request({
		url: `/user/product/evaluationList`,
		method: 'post',
		data
	})
}

//评论统计
export function CommentsStatistics(sysProCode){
	return Http.request({
		url: `/user/product/evaluationProductStatistics`,
		method: 'post',
		data:{
			sysProCode
		}
	})
}

//------------------购物车模块----------
//加入购物车
export function ShopCartAdd(data){
	return Http.request({
		url: `/user/cart/addCart`,
		method: 'post',
		data
	})
}

//编辑购物车
export function ShopCartEdit(data){
	return Http.request({
		url: `/user/cart/editCart`,
		method: 'post',
		data
	})
}

//购物车列表
export function ShopCartList(data){
	return Http.request({
		url: `/user/cart/getCartList`,
		method: 'post',
		data
	})
}

//购物车移除
export function ShopCartRemove(ids){
	return Http.request({
		url: `/user/cart/removeCarts`,
		method: 'post',
		data:{
			ids
		}
	})
}

//购物车数量
export function ShopCartNum(data){
	return Http.request({
		url: `/user/cart/getCartNum`,
		method: 'post',
		data
	})
}
//------------------购物车模块End----------


//-----------------订单模块----------------
//商品订单
export function OrderList(data){
	return Http.request({
		url: `/order/order/list`,
		method: 'post',
		data
	})
}

//商品订单详情
export function OrderDetails(batchSn,orderSn){
	return Http.request({
		url: `/order/order/detail`,
		method: 'post',
		data:{
			batchSn,
			orderSn
		}
	})
}

//查看物流
export function ExpressInfo(data){
	return Http.request({
		url: `/order/order/getExpress`,
		method: 'post',
		data
	})
}

//取消订单
export function OrderCancel(batchSn){
	return Http.request({
		url: `/order/order/cancel`,
		method: 'post',
		data:{
			batchSn
		}
	})
}

//确认收货
export function OrderConfirm(batchSn){
	return Http.request({
		url: `/order/order/confirmReceived`,
		method: 'post',
		data:{
			batchSn
		}
	})
}

//订单评价
export function OrderComments(data){
	return Http.request({
		url: `/order/order/orderEvaluation`,
		method: 'post',
		data
	})
}

//订单修改地址
export function OrderAddressChange(data){
	return Http.request({
		url: `/order/order/updateAddress`,
		method: 'post',
		data
	})
}

//订单角标
export function OrderBadge(data){
	return Http.request({
		url: `/order/order/orderCorner`,
		method: 'post',
		data
	})
}

//订单退款申请
export function OrderRefundApply(data){
	return Http.request({
		url: `/order/order/orderRefund`,
		method: 'post',
		data
	})
}

//订单退款取消
export function OrderRefundCancel(orderSn){
	return Http.request({
		url: `/order/order/orderCancelRefund`,
		method: 'post',
		data: {
			orderSn
		}
	})
}

//退款记录
export function OrderRefundRecords(data){
	return Http.request({
		url: `/pay/order/mallOrderRefundList`,
		method: 'post',
		data
	})
}

//退款详情
export function OrderRefundDetails(id){
	return Http.request({
		url: `/pay/order/getOrderRefund`,
		method: 'post',
		data: {
			id
		}
	})
}

//-----------------订单模块End----------------


//-----------------送礼模块--------------------



//获取礼物封面
export function GetGiftCoverImage(){
	return Http.request({
		url: `/user/gift/getGiftCoverImage`,
		method: 'post',
	})
}


//礼物列表
export function GetGiftList(data){
	return Http.request({
		url: `/user/gift/getGiftList`,
		method: 'post',
		data
	})
}


//操作礼物
export function GiftOperation(data){
	return Http.request({
		url: `/user/gift/giftOperation`,
		method: 'post',
		data
	})
}

//根据订单号生成礼物
export function SendGift(data){
	return Http.request({
		url: `/user/gift/sendGift`,
		method: 'post',
		data
	})
}

//打开礼物
export function OpenGift(id){
	return Http.request({
		url: `/user/gift/openGift/${id}`,
		method: 'get',
	})
}

//收藏
export function addCollect(data){
	return Http.request({
		url: `/user/member/likeProduct/add`,
		method: 'post',
		data
	})
}

//取消收藏
export function removeCollect(data){
	return Http.request({
		url: `/user/member/likeProduct/remove`,
		method: 'post',
		data
	})
}

//取消收藏
export function removeByProduct(data){
	return Http.request({
		url: `/user/member/likeProduct/removeByProductId`,
		method: 'post',
		data
	})
}

//收藏列表
export function getCollectList(data){
	return Http.request({
		url: `/user/member/likeProduct/getList`,
		method: 'post',
		data
	})
}

// 下载订单发票
export function downloadInvoice(orderSn) {
	const token = useUserStore().token || '';
	const url = `${baseUrl}/order/order/invoice?orderSn=${encodeURIComponent(orderSn)}`;
	return new Promise((resolve, reject) => {
		uni.downloadFile({
			url,
			header: { Authorization: token },
			success: (res) => {
				if (res.statusCode === 200) {
					uni.openDocument({
						filePath: res.tempFilePath,
						fileType: 'pdf',
						showMenu: true,
						success: () => resolve(),
						fail: (e) => reject(e)
					});
				} else {
					reject(new Error('下载失败'));
				}
			},
			fail: (e) => reject(e)
		});
	});
}



